export const IMAGE_SIZE_LIMIT = 4 * 1024 * 1024;
export const RESOURCE_SIZE_LIMIT = 200 * 1024 * 1024;
export const VIDEO_SIZE_LIMIT = 1024 * 1024 * 1024; // 1GB
export const FILE_FORMAT = {
  PDF: 'pdf',
  PPTX: 'pptx',
};
